// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:07:47

export default {
  "id": "motorcycle-racer-road-mayhem",
  "slug": "motorcycle-racer-road-mayhem",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/c1eab684f55f47a18136aec50a304e03-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/c1eab684f55f47a18136aec50a304e03/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Motorcycle Racer: Road Mayhem",
      "description": "Motorcycle Racer: Road Mayhem is an exciting motorcycle racing game. \nIn this game you will become a motorcycle racer who travels through city streets and highways, avoiding collisions with other vehicles. You will be able to unlock faster and more powerful motorcycles, each with its own unique handling characteristics, as well as improve the characteristics of your motorcycle. One of the key features of the game is a realistic physics engine that makes the gameplay challenging and exciting.",
      "instructions": "The goal of the game is to upgrade and buy motorcycles, participate in races and win at all levels.\nControl on a mobile device: touch.\nPC control: arrows for traffic",
      "genres": [
        "Agility",
        "Racing & Driving"
      ],
      "tags": [
        "bike",
        "block",
        "crash",
        "dirtbike",
        "motercycle"
      ]
    },
    "zh-CN": {
      "title": "摩托车赛车：公路混乱",
      "description": "《摩托车赛车手：街头混乱》是一款激动人心的摩托车赛车游戏。\n在这款游戏中，你将化身为一名摩托车赛车手，穿梭在城市街道和高速公路上，避开与其他车辆的碰撞。你将能够解锁更快、更强大的摩托车，每辆摩托车都有其独特的操控特性，同时还能提升你的摩托车的性能。游戏的关键特色之一是逼真的物理引擎，它使得游戏玩法充满挑战和乐趣。",
      "instructions": "游戏目标是升级和购买摩托车，参加比赛并在所有级别中获胜。\n移动设备上的控制：触摸。\nPC控制：使用箭头控制交通",
      "genres": [
        "敏捷性",
        "赛车与驾驶"
      ],
      "tags": [
        "自行车",
        "障碍物",
        "碰撞",
        "dirtbike（越野摩托车）",
        "摩托车"
      ]
    },
    "zh-TW": {
      "title": "摩托車賽車：公路混亂",
      "description": "摩托車賽車：街頭混亂是一款刺激的摩托車賽車遊戲。\n在這款遊戲中，你將成為一名摩托車賽車手，穿梭於都市街道和高速公路，避免與其他車輛相撞。你將能夠解鎖速度更快、性能更強大的摩托車，每款摩托車都有其獨特的操控特點，並且能夠提升你的摩托車性能。遊戲的關鍵特色是逼真的物理引擎，讓遊戲過程既挑戰又刺激。",
      "instructions": "遊戲的目的是升級和購買摩托車，參與賽事並在各級別獲勝。\n在行動裝置上的操控：觸控。\n在個人電腦上的操控：方向鍵控制交通",
      "genres": [
        "敏捷性",
        "賽車與駕駛"
      ],
      "tags": [
        "單車",
        "塊",
        "撞車",
        "dirtbike",
        "機車"
      ]
    },
    "zh-HK": {
      "title": "機車賽手：公路亂世",
      "description": "摩托車賽車：街頭混亂是一款刺激的摩托車賽車遊戲。\n在這款遊戲中，你將成為一名摩托車賽車手，穿梭於城市街道和高速公路，避免與其他車輛發生碰撞。你可以解鎖更快速、更強大的摩托車，每輛摩托車都有其獨特的操控特性，並且可以提升你的摩托車性能。遊戲的一個關鍵特色是實際的物理引擎，使遊戲操作具有挑戰性和刺激感。",
      "instructions": "遊戲目標是升級和購買電單車，參與賽事並在各級別獲勝。\n在移動裝置上的操控：觸碰。\n電腦操控：方向鍵操控車輛交通",
      "genres": [
        "敏捷度",
        "賽車與駕駛"
      ],
      "tags": [
        "單車",
        "堵車",
        "撞車",
        "dirtbike",
        "機車"
      ]
    },
    "ja": {
      "title": "バイクレーサー：ロード・メイヘム",
      "description": "モーターサイクルレーサー：ストリート・メイヘムは、興奮するモーターサイクルレースゲームです。\nこのゲームでは、街の通りや高速道路を駆け巡るモーターサイクルレーサーになることができます。他の車両との衝突を避けることができます。より速くてパワフルなモーターサイクルを解放し、それぞれが独自のハンドリング特性を持つようになり、あなたのモーターサイクルの特性を向上させることができます。このゲームの特徴の一つは、プレイを挑戦的で興奮させるリアルな物理エンジンです。",
      "instructions": "ゲームの目標は、バイクをアップグレードし購入し、レースに参加して全レベルで勝利することです。\nモバイル機器でのコントロール：タッチ。\nPCでのコントロール：トラフィック用の矢印",
      "genres": [
        "敏捷性",
        "レースとドライビング"
      ],
      "tags": [
        "自転車",
        "ブロック",
        "クラッシュ",
        "ダートバイク",
        "オートバイ"
      ]
    },
    "ko": {
      "title": "모터사이클 레이서: 로드 메이ヘ임",
      "description": "motorcycle racer: road mayhem은 흥미로운摩托车 경주 게임입니다. \n이 게임에서는 도시의 거리와 고속도로를 달리며 다른 차량과의 충돌을 피하는摩托车 경주선수가 됩니다. 더 빠르고 더 강력한摩托车를 해금할 수 있으며, 각摩托车는 독특한 핸들링 특성을 가지고 있으며, 자신의摩托车의 성능을 개선할 수 있습니다. 이 게임의 주요 기능 중 하나는 실제적인 물리 엔진으로, 게임 플레이를 도전적이고 흥미롭게 만듭니다.",
      "instructions": "게임의 목표는 모터사이클을 업그레이드하고 구매하고, 경주에 참가하여 모든 단계에서 승리하는 것입니다.\n모바일 장치에서의 제어: 터치.\nPC에서의 제어: 트래픽을 위한 방향키",
      "genres": [
        "敏捷性",
        "레이싱 & 드라이빙"
      ],
      "tags": [
        "바이크",
        "블록",
        "크래시",
        "더트바이크",
        "모터사이크ル"
      ]
    },
    "fr": {
      "title": "Motorcycle Racer : Chaos de Route",
      "description": "Motorcycle Racer: Road Mayhem est un jeu de course de motos passionnant. Dans ce jeu, vous deviendrez un pilote de motos qui se déplace à travers les rues de la ville et les autoroutes, en évitant les collisions avec d'autres véhicules. Vous pourrez déverrouiller des motos plus rapides et plus puissantes, chacune avec ses propres caractéristiques de pilotage uniques, ainsi que d'améliorer les caractéristiques de votre propre moto. Une des fonctionnalités clés du jeu est un moteur de physique réaliste qui rend le gameplay challengeant et captivant.",
      "instructions": "Le but du jeu est de mettre à niveau et d'acheter des motos, de participer à des courses et de gagner à tous les niveaux.\nContrôle sur un appareil mobile : toucher.\nContrôle sur PC : flèches pour la circulation.",
      "genres": [
        "Agilité",
        "Courses & conduite"
      ],
      "tags": [
        "vélo",
        "bloc",
        "accident",
        "dirtbike",
        "motocyclette"
      ]
    }
  }
};
